import { lazy } from 'react';
import PageView from './PageView';

const CustomerBlacklistPage = lazy(() => import('src/pages/customerBlacklist'));

export const customerBlacklistRoutes = [
  {
    path: 'customer-blacklist',
    element: <PageView permission="BO_CAN_VIEW_BLACK_LIST" />,
    children: [{ element: <CustomerBlacklistPage />, index: true }],
  },
];
